import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

// Layout
import Header2 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Elements
import Slider from '../elements/slider/slider2';
import BlogSlider from '../elements/blog/blog-slider';
import ProjectSlider7 from '../elements/project-slider/project-slider-7';
import Testimonial3 from '../elements/testimonial/testimonial3';
import Count from '../elements/counter/counter-sensor';

// Images
import BackBg1 from "../../images/background/bg1.png"
import BackBg2 from "../../images/background/bg2.png"
import BackBg4 from "../../images/background/bg4.jpg"
import AboutPic14 from "../../images/intro-sec-img-1.webp"
import AboutPic15 from "../../images/gops-inspection-intro-img.webp"
import ServicesPic1 from "../../images/our-services/services-1/pic1.jpg"
import ServicesPic2 from "../../images/our-services/services-1/pic2.jpg"
import ServicesPic3 from "../../images/our-services/services-1/pic3.jpg"
import ServicesPic4 from "../../images/our-services/services-1/pic4.jpg"
import ServicesPic5 from "../../images/our-services/services-1/pic5.jpg"
import ServicesPic6 from "../../images/our-services/services-1/pic6.jpg"
import PortImg1 from "../../images/industrie/oil&gas.jpg"
import PortImg2 from "../../images/industrie/petro.jpg"
import PortImg6 from '../../images/electric4.jpg'
import PortImg3 from "../../images/industrie/power.png"
import PortImg4 from "../../images/industrie/water.jpg"
import PortImg5 from "../../images/industrie/mining.png"
import TeamPic1 from "../../images/logo-white.png"
import TeamPic2 from "../../images/logo-white.png"
import TeamPic3 from "../../images/logo-white.png"
import TeamPic4 from "../../images/logo-white.png"
import Services3 from '../elements/services/services-3';
// Images
import Banner1 from '../../images/banner/banner1.jpg';
import Awards1 from '../../images/awards/pic1.jpg';
import Awards2 from '../../images/awards/pic2.jpg';
import Awards3 from '../../images/awards/pic3.jpg';
import AboutPic6 from '../../images/about/pic6.jpg';
import AboutPic8 from '../../images/about/pic8.jpg';
import AboutPic9 from '../../images/about/pic9.jpg';
import AboutPic10 from '../../images/about/pic10.jpg';
import Sign from '../../images/sign.png';
import ClientLogo1 from '../elements/client-logo/client-logo-1';

class Index2 extends Component {
	
	render(){
		return (
			<>
				
				<Header2 />
				
				<div className="page-content bg-white" style={{paddingBottom:0}}>
					
					<Slider />
				
					{/* <!-- Main Slider --> */}
					<div className="content-block" id="content-area" style={{paddingBottom:0}}>
						
						<div className="section-area section-sp2 bg-white" style={{backgroundImage:"url("+BackBg2+")", backgroundPosition:"bottom", backgroundSize:"100%"}}>
							<div className="container">
								<div className="row align-items-center">
									<div className="col-lg-6 col-md-12 wow fadeIn m-md-b40" data-wow-delay="0.3s">
										<div className="heading-bx m-b30">
											<h6 className="title-ext m-b0">Welcome to GOPS</h6>
											<h2 className="title-head m-b0">About Us GOPS</h2>
											<div className="ttr-separator sepimg"></div>
											<p className="head-px2">GO-PS propose a consistently high-performance solutions to our clients in Algeria, Libya, Mauritania, through partnerships with international service providers, new technology developers, and certified suppliers to cover a wide range of needs related the oil & gas and energy markets. 
											Our efforts aim to create a sustainable local platform for multinational companies to provide a diverse range of products and services that add value to our clients by focusing on quality, integrity, and operational safety.
											.</p>
										</div>
										<div className="row m-b10">
											<div className="col-md-6">
												<ul className="list-check primary fs18">
													<li>Oil & Gas (Onshore / Offshore)</li>
													<li>Petrochemicals</li>
													<li>Mining</li>
													<li>Water treatment and Desalination</li>
												</ul>
											</div>
											<div className="col-md-6">
												<ul className="list-check primary fs18">
													<li>Electrical & Power Engineering</li>
													<li>Automation, SCADA & Digital Energy</li>
													<li>Power & Renewable Energies</li>
													<li>Project Management & Lifecycle Support</li>
												</ul>
											</div>
										</div>
										<Link to="contact" className="btn m-r10">Contact Us</Link>
									</div>
									<div className="col-lg-6 col-md-12 wow fadeIn" data-wow-delay="0.6s">
										<div className="about-img-box4 row sp10">
											<div className="col-lg-12">
												<div className="about-img1">
													<img src={AboutPic14} alt=""/>
												</div>
											</div>
											<div className="col-lg-12 m-b10 m-t10">
												<div className="about-img2">
													<img src={AboutPic15} alt=""/>
												</div>
											</div>
											<div className="about-img-inner">
												<div>
													<h2 className="title"><Count counter={20}/>+</h2>
													<span>YEAR WORK IN INDUSTRY</span>
												</div>
											</div> 
										</div>
									</div>
								</div>
							</div>
						</div>
						
						
						{/* <div className="section-area section-sp2 bg-white" style={{backgroundImage:"url("+BackBg2+")", backgroundPosition:"bottom", backgroundSize:"100%"}}>
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className="heading-bx text-center">
											<h6 className="title-ext m-b0">Services</h6>
											<h2 className="title-head m-b0">Our Services</h2>
											<div className="ttr-separator sepimg"></div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic1} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">Solar Panels</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic2} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">Wind Turbines</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic3} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">Green Equipment</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic4} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">Lower Power Cost</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic5} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">Generate Electricity</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
									<div className="col-xl-4 col-lg-6 col-md-6 m-b30">
										<div className="service-bx style1">
											<div className="service-media">
												<img src={ServicesPic6} alt=""/>
											</div>
											<div className="service-info">
												<h4 className="title">The Environment</h4>
												<p>There are many variations</p>
												<Link to="services-details" className="btn-link">Read More</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> */}
	 
						<div className="section-area section-sp1 bg-primary" style={{backgroundImage:"url("+BackBg1+")", backgroundPosition:"bottom", backgroundSize:"100%"}}>
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className="heading-bx text-white text-center">
											<h6 className="title-ext m-b0">GO-PS</h6>
											<h2 className="title-head m-b0">Our Professional areas</h2>
											<div className="ttr-separator sepimg2"></div>
										</div>
									</div>
								</div>
								<Tabs className="history-box">

									<TabList className="nav nav-tabs">
										<Tab>Oil & Gas (Onshore / Offshore)</Tab>
										<Tab>Electrical & Power Engineering</Tab>
										<Tab>Petrochemicals</Tab>
										<Tab>Power & Renewable Energies</Tab>
										<Tab>Water treatment and Desalination</Tab>
										<Tab>Mining</Tab>
									</TabList>

									<TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6">
												<img src={PortImg1} alt=""/>
											</div>
											<div className="col-xl-7 col-lg-6" >
												<div className="history-info">
													<h3>Oil & Gas (Onshore / Offshore)</h3>
													<p>Our purpose is to deliver advanced engineering and operational solutions supporting onshore and offshore oil and gas developments and long-term field performance.</p>
													<p>Our purpose is to provide integrated technologies enhancing exploration, drilling, production, and facility operations across diverse offshore and onshore assets.</p>
													<p>Our purpose is to support operators with reliable services designed to optimize efficiency, integrity, and sustainable oil and gas operations.</p>
												</div>
											</div>
										</div>
									</TabPanel>
                                    <TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6">
												<img src={PortImg6} alt=""/>
											</div>
											<div className="col-xl-7 col-lg-6">
												<div className="history-info">
													<h3>Electrical & Power Engineering Services</h3>
													<p>
														Our purpose is to deliver reliable electrical and power engineering solutions supporting
														industrial facilities, Oil & Gas installations, and energy infrastructure.
													</p>
													<p>
														Our purpose is to enhance system safety, availability, and efficiency through optimized
														power distribution networks, substations, and backup energy systems.
													</p>
													<p>
														Our purpose is to support long-term asset performance through modernisation, compliance
														upgrades, and advanced power system studies.
													</p>
												</div>
											</div>
										</div>
									</TabPanel>

									<TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6">
												<img src={PortImg2} alt=""/>
											</div>
											<div className="col-xl-7 col-lg-6">
												<div className="history-info">
													<h3>Petrochemicals</h3>
													<p>Our purpose is to deliver specialised engineering and process solutions tailored to petrochemical plants and industrial transformation facilities globally.</p>
													<p>Our purpose is to strengthen production reliability through advanced technologies, performance chemicals, and integrated technical assistance.</p>
													<p>Our purpose is to help petrochemical operators achieve safer, cleaner, and more efficient performance across all major processing units.</p>

												</div>
											</div>
										</div>
									</TabPanel>
									<TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6" >
												<img src={PortImg3} alt="" />
											</div>
											<div className="col-xl-7 col-lg-6">
												<div className="history-info">
													<h3>Power & Renewable Energies</h3>
													<p>Our purpose is to provide innovative engineering and service solutions supporting thermal, solar, wind, and hybrid renewable energy systems.</p>
													<p>Our purpose is to enhance generation efficiency and system reliability through modern technologies, digital tools, and specialised field services.</p>
													<p>Our purpose is to promote sustainable development through integrated clean-energy solutions that reinforce resilience and environmental performance.</p>

												</div>
											</div>
										</div>
									</TabPanel>
									<TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6">
												<img src={PortImg4} alt=""/>
											</div>
											<div className="col-xl-7 col-lg-6">
												<div className="history-info">
													<h3>Water treatment and Desalination</h3>
													<p>Our purpose is to deliver advanced water purification, desalination, and wastewater treatment solutions for industrial and municipal applications.</p>
													<p>Our purpose is to improve plant efficiency using modern membranes, specialised chemicals, intelligent monitoring systems, and tailored support.</p>
													<p>Our purpose is to provide sustainable and cost-effective solutions helping operators meet stringent water-quality and operational requirements.</p>

												</div>
											</div>
										</div>
									</TabPanel>
									<TabPanel>
										<div className="row align-items-center text-white">
											<div className="col-xl-5 col-lg-6">
												<img src={PortImg5} alt=""/>
											</div>
											<div className="col-xl-7 col-lg-6">
												<div className="history-info">
													<h3>Mining</h3>
													<p>Our purpose is to deliver engineering and operational solutions that enhance extraction, processing, and mineral-handling performance in mining projects.</p>
													<p>Our purpose is to support mining operations with reliable technologies, modern equipment, and services focused on productivity and site safety.</p>
													<p>Our purpose is to ensure efficient and sustainable resource development through integrated mining solutions adapted to challenging environments.</p>

												</div>
											</div>
										</div>
									</TabPanel>
								</Tabs>
							</div>
						</div>
						<Services3 />
						</div>
						<div className="section-area section-sp2 bg-gray">
							<div className="container wow fadeIn" data-wow-delay="0.8s">
								<div className="heading-bx text-center">
									<h6 className="title-ext m-b0">Our Partner</h6>
									<h2 className="title-head m-b0">Partners & Clients</h2>
									<div className="ttr-separator sepimg"></div>
								</div>
								<ClientLogo1 />
							</div>
						   </div>
						{/* <div className="section-area section-sp2 bg-white" style={{backgroundImage:"url("+BackBg2+")", backgroundPosition:"bottom", backgroundSize:"100%"}}>
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<div className="heading-bx text-center m-b0">
											<h6 className="title-ext m-b0">GO-PS</h6>
											<h2 className="title-head m-b0">Company History</h2>
										</div>
									</div>
								</div>
							</div>
							<div className="section-area section-sp2 bg-white">
								<div className="container">		
									<div className="timeline-view">
										<div className="timeline-area">
											<div className="timeline-date">
												<div className="sticky-top">
													<div className="date-bx">1892</div>
													<h6>VISION TO PLAN</h6>
													<h4>Iterative approaches</h4>
													<p>Dynamically innovate resource-leveling customer service for state of the art customer service.</p>
												</div>
											</div>
											<div className="timeline-content">
												<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look.</p>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
												<p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
												<div className="row">
													<div className="col-md-4 m-b30">
														<img src={AboutPic8} alt=""/>
													</div>
													<div className="col-md-4 m-b30">
														<img src={AboutPic9} alt=""/>
													</div>
													<div className="col-md-4 m-b30">
														<img src={AboutPic10} alt=""/>
													</div>
												</div>
											</div>
										</div>
										<div className="timeline-area">
											<div className="timeline-date">
												<div className="sticky-top">
													<div className="date-bx">1957</div>
													<h6>PLAN TO MARKET</h6>
													<h4>Customer service</h4>
													<p>Dynamically innovate resource-leveling customer service for state of the art customer service.</p>
												</div>
											</div>
											<div className="timeline-content">
												<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look.</p>
												<div className="skillbar-box">
													<h6 className="title">Plan to Market</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width:"96%"}}></p>
														<span className="skill-bar-percent">96%</span>
													</div>
												</div>
												<div className="skillbar-box">
													<h6 className="title">Market to Growth</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width:"92%"}}></p>
														<span className="skill-bar-percent">92%</span>
													</div>
												</div>
												<div className="skillbar-box">
													<h6 className="title">Customer service</h6>
													<div className="skillbar appear">
														<p className="skillbar-bar" style={{width:"79%"}}></p>
														<span className="skill-bar-percent">79%</span>
													</div>
												</div>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
												<p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
												<div className="row">
													<div className="col-md-6 m-b30">
														<img src={AboutPic9} alt=""/>
													</div>
													<div className="col-md-6 m-b30">
														<img src={AboutPic8} alt=""/>
													</div>
												</div>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
											</div>
										</div>
										<div className="timeline-area">
											<div className="timeline-date">
												<div className="sticky-top">
													<div className="date-bx">2004</div>
													<h6>PLAN TO MARKET</h6>
													<h4>Visualize quality</h4>
													<p>Dynamically innovate resource-leveling customer service for state of the art customer service.</p>
												</div>
											</div>
											<div className="timeline-content">
												<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look.</p>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
												<div className="row">
													<div className="col-md-12 m-b30">
														<img src={AboutPic6} alt=""/>
													</div>
												</div>
												<p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
											</div>
										</div>
										<div className="timeline-area">
											<div className="timeline-date">
												<div className="sticky-top">
													<div className="date-bx">2018</div>
													<h6>PLAN TO MARKET</h6>
													<h4>Visualize quality</h4>
													<p>Dynamically innovate resource-leveling customer service for state of the art customer service.</p>
												</div>
											</div>
											<div className="timeline-content">
												<div className="row">
													<div className="col-md-6">
														<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look.</p>
													</div>
													<div className="col-md-6">
														<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there.</p>
													</div>
												</div>
												<p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
												<p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
												<div className="sign-bx">
													<div className="sign-img">
														<img src={Sign} alt=""/>
													</div>
													<div className="author-bx">
														<h5 className="title">Robert Smith</h5>
														<span>CEO AND Founder</span>
													</div>
												</div>
											</div>
										</div>
									</div>
							</div>
						   </div>
						 </div> */}
							
						
							
					
				</div>
				
				<Footer1 />
				
			</>
		);
	}
}

export default Index2;